import {create } from "zustand";
import { CatchWrapperAsync } from "../utils/catchwrapper";
import AxiosFetchData from "../pages/AxiosFetchData";
import Bindcomponent from "../utils/bindcomponent";

const useStoreUser = create((set) => ({
// todos: [],
  roleAccess : '',
  role : '',
  rows : [],
   
  fetch: (Navigate, setmessage, setTypeError) =>{
    let response;
     CatchWrapperAsync(async () =>{
              response = await AxiosFetchData.get(`GetStatus`).refreshToken(Navigate,"users",true);
              if(response){
                set((state) => ({roleaAccess : response.roleaccess,   rows : response.data}))
              }
     }, setmessage, setTypeError)
  },
    
  handleDeleteStatus: (data, Navigate,setmessage,setTypeError) =>
  {
     CatchWrapperAsync(async () => {
          const response = await AxiosFetchData.delete(`DeleteUser/${data}`).refreshToken(Navigate,"users");
          if(response){
            set((state) => ({
                  rows: state.rows.filter((row) => row.id !== data,
                ),
            }))
          }
          setmessage(response.data);
      },setmessage,setTypeError)
  },
 
}));

export default useStoreUser;